var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatGroupIconButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.99967C0.9 5.99967 0 6.89967 0 7.99967C0 9.09967 0.9 9.99967 2 9.99967C3.1 9.99967 4 9.09967 4 7.99967C4 6.89967 3.1 5.99967 2 5.99967ZM2 -0.000328064C0.9 -0.000328064 0 0.899672 0 1.99967C0 3.09967 0.9 3.99967 2 3.99967C3.1 3.99967 4 3.09967 4 1.99967C4 0.899672 3.1 -0.000328064 2 -0.000328064ZM2 11.9997C0.9 11.9997 0 12.8997 0 13.9997C0 15.0997 0.9 15.9997 2 15.9997C3.1 15.9997 4 15.0997 4 13.9997C4 12.8997 3.1 11.9997 2 11.9997Z",
    fill: "#6E6E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGroupIconButton);
export default __webpack_public_path__ + "static/media/chatGroupIconButton.a5025c0d.svg";
export { ForwardRef as ReactComponent };